import { useNavigate } from 'react-router-dom';


import {Alert, AlertTitle, Box, Button, CircularProgress, IconButton,
    Popover, Select, Snackbar, Radio,
    Stack, ThemeProvider, Typography} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import { useParams } from "react-router-dom";

import { useState, useEffect, useRef, useCallback, } from 'react';
import {HrefSelector} from "../components/hrefSelector";


import { Icon as Iconify } from '@iconify/react';
import axios from 'axios';
import { lionIcons } from '../components/helpersIcons';
import { GetFilterDefFromMetadata}  from '../components/helpers';

import TemplateVariantsEditor from '../components/templateVariantsEditor';

import { LabelManager } from '../components/labelManager';


import { CcStepper2} from "../commonComponents/stepper"
import {ccColorDarkTeal, ccColorOrange, ccColorSecondaryAzure, ccColorTeal, lionObjectsColors}  from "../components/helpersStyles";
import {CcButton, InputText, DisbaledInputText, InputNumber, InputDigit, LionListbox} from "../commonComponents/inputFields"
import { CcSubSectionTitle, CcTitle } from '../commonComponents/styledTexts';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaVariantViewer_snippetSettings, snippetDataValidationSchemaGenerator } from '../components/helperErrors'

import { CcLoader } from '../commonComponents/generalComponents';
import { TemplateGalleryViewer } from '../commonComponents/templateGallery';

import { DatabindingSelector } from '../components/templateEditor';
import { CodeViewer } from '../Pages/PageApollodorus';
import { CssBorderManager } from '../commonComponents/cssBorderManager';
import { LionColorPicker } from '../components/lionColorPicker';
import { InfoToolTip } from '../commonComponents/generalComponents';

const VariantsBindingsSelector = (props) => {

  useEffect(() => {
    console.log(props.validationErrorsList)
  }, [props.validationErrorsList])

  const handleDatabindChange = (index, bindType, dataBindValue, designTimeValue) => {
    const newVariants = [...props.variantsBindings]
    newVariants[index] = dataBindValue
    if (props.onChange) props.onChange(newVariants)
  }

  return <div className='text-ccColorDarkTeal'>
            <div className='font-poppins text-lg mb-1'>Define the bindings for each variant</div>
            <div className='w-56'>
              <DisbaledInputText displayName="Default databind" value={props.dataBindValue} />
            </div>
            <div>
              {props.variantsBindings.map((v, index) => <div className='flex flex-row items-center w-60'>
                        <InputText displayName={`Variant ${index +1}`} value={v}
                                    disabled
                                      error={getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsVariantsBindings', index)}
                        />
                        <div className='mt-[18px]'>
                          <DatabindingSelector //dataBindValue={activeSelection.attrs.textRaw}
                              sampleData={props.sampleData}
                              noPreview
                              dataBindType="databind"
                              dataBindTypes={['databind']}
                              onChange={(bindType, dataBindValue, designTimeValue) => handleDatabindChange(index, bindType, dataBindValue, designTimeValue)} />
                        </div>
              </div>)}
            </div>
  </div>
}

const NumVariantsSelector = (props) => {

  const handleDigitChange = (digit) => {
    if (props.onChange) props.onChange(digit)
  }

  return <div className='text-ccColorDarkTeal p-2 border border-ccColorDarkTeal rounded'>
            <div className='font-poppins text-xl font-semibold'>How many total images would you like to display?</div>
            <div className='w-56 mt-2'>
              <InputDigit value={props.numVariants} min={2} max={5}
                onChange={handleDigitChange}
              />
            </div>
            <div>
            </div>
  </div>
}

const VariantsSelector = (props) => {
    //props:
    // variantsSettings: an object with all the settings

    const [sampleData, setSampleData] = useState(undefined)
    //display a template, allow to select the image block that
    //will contain the variant images
    //allows to select the databind for each variant
    const [variantsBindings, setVariantsBindings] = useState([''])

    useEffect(() => {
      if (props.variantsSettings.selectedImageBlockId == null || props.variantsSettings.selectedImageBlockId.length === 0) {
        
      }
      if (props.variantsSettings.variantsBindings) {
        //setNumVariants(props.variantsSettings.variantsBindings ? props.variantsSettings.variantsBindings.length +1 : 2)
        setVariantsBindings(props.variantsSettings.variantsBindings)
      }
    }, [props.variantsSettings])

    const updateSettingsProp = (propName, propValue) => {
      return {...props.variantsSettings, [propName]: propValue}
    }
  
  const handleSelectedImageBlockChange = (block) => {
    const dataBindType = block.attrs.dataBindType
    let dataBindValue = block.attrs.dataBindValue
    if (dataBindType === 'none') dataBindValue = "None (fixed image)"

    //setSelectedImageBlockDataBindValue(dataBindValue)

    //console.log(block)
    const newSettings = { variantsBindings: variantsBindings, 
                            selectedImageBlockId: block.attrs.id,
                            selectedImageBlockDataBindValue: dataBindValue,
                            dataBindType: dataBindType
                          }
    //setSelectedImageBlockId(block.attrs.id)
    if (props.onChange) props.onChange(newSettings)
  }

  const handleNumVariantsChange = (num) => {
    //num can only differ by +1 or -1 from numVariants
    //so we use a simple algorith here
    //setNumVariants(num)
    //const variantsBindings = props.variantsSettings.variantsBindings ? props.variantsSettings.variantsBindings : ['']
    let newVariants = [...variantsBindings]
    if (variantsBindings.length < num -1) {
      //need to add 1
      newVariants.push('')
    }
    if (variantsBindings.length > num -1) {
      //need to subtract 1
      newVariants.splice(newVariants.length-1,1)
    }

    //setVariantsBindings(newVariants)
    const newSettings = updateSettingsProp('variantsBindings', newVariants)
    //console.log(newSettings)
    if (props.onChange) props.onChange(newSettings)
  }
  const handleVariantsBindingsChange = (newBindings) => {
    //setVariantsBindings(newBindings)
    const newSettings = updateSettingsProp('variantsBindings', newBindings)
    if (props.onChange) props.onChange(newSettings)
  }

    return <div className='grid grid-cols-2 gap-x-4'>
                <div className='mb-2'>
                  <NumVariantsSelector numVariants={variantsBindings.length + 1} onChange={handleNumVariantsChange} />
                </div>
                <div className=''>
                </div>
                  
                <TemplateVariantsEditor id={props.templateId}
                    embeddedInWizard
                    onChange={handleSelectedImageBlockChange}
                    onSampleDataRetrieved={setSampleData}
                    selectedImageBlockId={props.variantsSettings.selectedImageBlockId}
                  />
                  
                <div>
                  <VariantsBindingsSelector
                    dataBindValue={props.variantsSettings.selectedImageBlockDataBindValue}
                    variantsBindings={props.variantsSettings.variantsBindings ? props.variantsSettings.variantsBindings : ['']}
                    sampleData={sampleData}
                    onChange={handleVariantsBindingsChange}
                    validationErrorsList={props.validationErrorsList}
                  />
                </div>
        </div>
}




export function VariantsViewerElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )
  templateMetadata: mandatory to pass to see previews

  onChange: returns all the snippet info
  */

  const activeStep = 3; //refactor - remove this variable
  const initialState = {snippetId: 0, snippetName: '', snippetDesc: '', 
  labels: [{labelId: 0, labelName: ''}], href: '',
  snippetTypeId: 21,
  filters: [], orderBy: [],
  dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};
  
  
  const [snippetInfo, setSnippetInfo] = useState(initialState);
  const [snippetSettings, setSnippetSettings] = useState({});
  const [popupLabelManagerValue, setPopupLabelManagerValue] = useState({snippetId: 0, data: []});
  const [snippetPreviewImages, setSnippetPreviewImages] = useState({1: {state: 'empty'}}); // Dictionary keys are pos 1, 2 etc... state can be: 'empty', 'loading' or 'loaded' 



  useEffect(() => {
    if (props.snippetInfo && props.templateId) {
      setSnippetInfo({...props.snippetInfo, templateId: props.templateId})
      let snippetSettingsParsed = {}
      if (props.snippetInfo.snippetSettings) snippetSettingsParsed = JSON.parse(props.snippetInfo.snippetSettings)
      if (snippetSettingsParsed.numTags == null) { //if numTags not provided we default to 1
        handleUpdateNumTags(1, {...props.snippetInfo, snippetSettings: snippetSettingsParsed})
        return
      }
      setSnippetSettings(snippetSettingsParsed)
      if (props.snippetInfo.labels && props.snippetInfo.labels.length > 0) {
        //prepare an object that the label manager can use
        const labels = {snippetId: 0, data: props.snippetInfo.labels}
        setPopupLabelManagerValue(labels)
      }
    }

  }, [props.snippetInfo, props.templateId])

  const handleChange = (propName, propValue) => {
    const newSnippetInfo = {...snippetInfo, [propName]: propValue}
    setSnippetInfo(newSnippetInfo);
    if (props.onChange) props.onChange(newSnippetInfo)
  }
  const handleLabelChanges = (lbls) => {
    const newSnippetInfo = {...snippetInfo, labels: lbls}
    setSnippetInfo(newSnippetInfo);
    if (props.onChange) props.onChange(newSnippetInfo)
      // console.log(newSnippetInfo)
  }
  const updateTestLinks = (link) => {
    // if images are not 'loaded' we do nothing
    if (snippetPreviewImages[1].state !== 'loaded') return;
   
    // we find the link and add it to test in the UI
    const newSnippetPreviewImages = {}
    const regex = "\\$\\{(.*?)\\}"
    const matches = [...link.matchAll(regex)];
    
    Object.keys(snippetPreviewImages).forEach(key => {
      let testLink = link;
      matches.forEach(m => {
        testLink = testLink.replaceAll(m[0], snippetPreviewImages[key].dataRow[m[1]])
      })
      newSnippetPreviewImages[key] = {...snippetPreviewImages[key], href: testLink}
    })
    setSnippetPreviewImages(newSnippetPreviewImages)
  
  }
  const handleUpdateNumTags = (num, newSnippetInfo) => {
    let newSettings = {}
    let result = {}

    if (newSnippetInfo) {
      newSettings = {...newSnippetInfo.snippetSettings, numTags: num}
      result = {...newSnippetInfo, snippetSettings: JSON.stringify(newSettings)}
    }
    else {
      newSettings = {...snippetSettings, numTags: num}
      result = {...snippetInfo, snippetSettings: JSON.stringify(newSettings)}
    }
    if (props.onNumTagsChange) props.onNumTagsChange(result)
  }
              
      
  return <div className='max-w-2xl'>
  <Stack spacing={2} >
    <InputText displayName="Name"
          value={snippetInfo.snippetName}      
          onChange={(val) => {handleChange('snippetName', val);}}
          error={getErrorMessage(props.validationErrorsList, 'snippetName')}
    />
    <InputText displayName="Description"
          value={snippetInfo.snippetDesc}      
          onChange={(val) => {handleChange('snippetDesc', val);}}
          error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
    />

      <LabelManager data={popupLabelManagerValue}
              compact
              onChange={handleLabelChanges}
        />
      <HrefSelector href={snippetInfo.href} fields={props.availableFieldsForHref}
                  onChange={(link) => {handleChange('href', link); updateTestLinks(link);}}
                  error={getErrorMessage(props.validationErrorsList, 'href') === undefined ? false : true}
                  helperText={getErrorMessage(props.validationErrorsList, 'href')}
      
      />

    <div>
      <div>How many tags do you need?</div>
      <div className='w-56'>
        <InputDigit value={snippetSettings?.numTags} min={1} max={10}
          onChange={handleUpdateNumTags}
        />
      </div>
    </div>

   </Stack>

</div>

}

const VariantsSelectorManager = (props) => {
  const defaultSelectorSettings = {style: 'thumbnail', marginTop: 4}
  const [imageSize, setImageSize] = useState({width: 0, height: 0}) //this represents the size of the Generator image (it excludes the space taken by the selector)

  useEffect(() => {
    if (props.template) {
      setImageSize({width: props.template.canvas.width, height: props.template.canvas.height})
    }

  }, [props.template])

  useEffect(() => {
    //console.log(props.variantsSettings)
    if (props.variantsSettings.selectors == null) {
      //setting defaults
      const newSettings = {...props.variantsSettings, selectors: defaultSelectorSettings}
      if (props.onChange) props.onChange(newSettings)
    }
    else {
      //we might need to set some defaults here, in case we added new settings
      //and some old tags might not have them
      if (props.variantsSettings.selectors.marginTop == null) {
        //setting defaults
        updateSelectorProp("marginTop", 4)
      }
      if (props.variantsSettings.selectors.spaceBetweenSelectors == null) {
        //setting defaults
        updateSelectorProp("spaceBetweenSelectors", 4)
      }
      if (props.variantsSettings.selectors.thumbnailBorder == null) {
        //setting defaults
        updateSelectorProp("thumbnailBorder", "1px solid #999")
      }
      if (props.variantsSettings.selectors.thumbnailSelectedColor == null) {
        //setting defaults
        updateSelectorProp("thumbnailSelectedColor", ccColorTeal)
      }
      if (props.variantsSettings.selectors.colors == null) {
        //setting defaults
        const defaultColors = []
        for (let i=0; i< props.variantsSettings.variantsBindings.length+1; i+=1) defaultColors.push(ccColorOrange)
        updateSelectorProp("colors", defaultColors)
      }
      if (props.variantsSettings.selectors.colorBorder == null) {
        //setting defaults
        updateSelectorProp("colorBorder", "1px solid #999")
      }

    }
  }, [props.variantsSettings])

  const getThumbHeight = (thumbWidth) => {
    if (thumbWidth === 0) return 0

    const thumbHeight = imageSize.height * thumbWidth / imageSize.width
    return thumbHeight
  }
  const updateSelectorProp = (propName, propValue) => {
    const newSelectorProps = {...props.variantsSettings.selectors, [propName]: propValue}
    //console.log(newSelectorProps)
    const newSettings = {...props.variantsSettings, selectors: newSelectorProps}

      if (props.onChange) props.onChange(newSettings)
  }
  const updateSelectorColorsArray = (index, color) => {
    const newColors = [...props.variantsSettings.selectors.colors]
    newColors.splice(index, 1, color)
    updateSelectorProp("colors", newColors);
  }

  return <div className='grid grid-cols-2'>
    <div>
      <div>Settings</div>
      <div>
        {props.variantsSettings.selectors && <>
          <div>Selector Style</div>

          <div class="inline-flex rounded-md shadow-sm font-poppins" role="group">
            <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.variantsSettings.selectors.style === 'thumbnail' ? 'bg-gray-200' : 'bg-white'}`}
                  onClick={()=>{updateSelectorProp('style', 'thumbnail')}}>
              <div>
                Thumbnail
              </div>
              <div className='text-sm mt-2 font-normal'>Display a thumbnail of the image. </div>
            </div>
            <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.variantsSettings.selectors.style === 'color' ? 'bg-gray-200' : 'bg-white'}`}
                onClick={()=>{updateSelectorProp('style', 'color')}}>
              <div>
                Circles
              </div>
              <div className='text-sm mt-2 font-normal'>Coloured circles. Good to select variants by colour</div>
            </div>
          </div>

          <div className='flex flex-row gap-x-16'>
            <div className='mt-2 w-56'>
              <InputNumber displayName="Margin from image on top (px)"
                min={0} max={100} incr={2}
                onChange={(val) => updateSelectorProp("marginTop", val)}
                value={props.variantsSettings.selectors.marginTop}
              />
            </div>
            <div className='mt-2 w-56'>
              <InputNumber displayName="Space between selectors (px)"
                min={0} max={100} incr={2}
                onChange={(val) => updateSelectorProp("spaceBetweenSelectors", val)}
                value={props.variantsSettings.selectors.spaceBetweenSelectors}
              />
            </div>

          </div>

          {props.variantsSettings.selectors.style === "thumbnail" && <>
            <div className='mt-2'>
              <CssBorderManager
                displayName="Selectors border"
                value={props.variantsSettings.selectors.thumbnailBorder}
                onChange={(val) => updateSelectorProp("thumbnailBorder", val)}
              />
            </div>
            <div className='mt-2'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                Selected Colour
                </div>
                <LionColorPicker color={props.variantsSettings.selectors.thumbnailSelectedColor}
                    onChange={(color) => updateSelectorProp('thumbnailSelectedColor', color)}
                />
            </div>
          </>}
          {props.variantsSettings.selectors.style === "color" && <>
            <div className='flex flex-row gap-x-4 flex-wrap'>
              {props.variantsSettings.selectors.colors.map((c, index) =>  <div className='mt-2'>
                        <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                        Color {index}
                        </div>
                        <LionColorPicker color={c}
                            onChange={(color) => updateSelectorColorsArray(index, color)}
                        />
                </div>)

              }
            </div>
            <div className='mt-2'>
              <CssBorderManager
                displayName="Selected border"
                value={props.variantsSettings.selectors.colorBorder}
                onChange={(val) => updateSelectorProp("colorBorder", val)}
              />
            </div>

          </>}

        </>}

      </div>      

    </div>
    <div className='flex flex-col items-center'>
      <div>Preview</div>
      <div style={{width: imageSize.width, height: imageSize.height}} className='bg-slate-200 flex items-center justify-center'><div className='font-poppins text-gray-600 text-lg'>Main Image</div></div>
      {props.variantsSettings.selectors && <div>
        {props.variantsSettings.selectors.style === 'thumbnail' && <div>
          {[...Array(props.variantsSettings.variantsBindings.length +1).keys()].map((_, index) => <div style={{display: "inline-block", marginTop: `${props.variantsSettings.selectors.marginTop}px`, marginRight: `${props.variantsSettings.selectors.spaceBetweenSelectors /2}px`, marginLeft: `${props.variantsSettings.selectors.spaceBetweenSelectors/2}px`, padding: "6px", border: `${props.variantsSettings.selectors.thumbnailBorder}`, borderRadius: "4px", backgroundColor: index === 0 ? props.variantsSettings.selectors.thumbnailSelectedColor : ""}}>
            <div style={{width: 36, height: getThumbHeight(36)}} className='bg-slate-200 text-xs'>Img</div>
          </div>)}
        </div>
        }
        {props.variantsSettings.selectors.style === 'color' && <div>
          {[...Array(props.variantsSettings.variantsBindings.length +1).keys()].map((_, index) => <div style={{display: "inline-block", width: `${28 + (props.variantsSettings.selectors.colorBorder ? parseInt(props.variantsSettings.selectors.colorBorder.split()[0].replace("px",""))*2:2)}px`, height: `${28 + (props.variantsSettings.selectors.colorBorder ? parseInt(props.variantsSettings.selectors.colorBorder.split()[0].replace("px",""))*2:2)}px`, marginTop: `${props.variantsSettings.selectors.marginTop}px`, marginRight: `${props.variantsSettings.selectors.spaceBetweenSelectors/2}px`, marginLeft: `${props.variantsSettings.selectors.spaceBetweenSelectors/2}px`, borderRadius: "50%", border: index === 0 ? props.variantsSettings.selectors.colorBorder : `${props.variantsSettings.selectors.colorBorder.split(" ")[0]} solid transparent`, padding: index === 0 ? "2px" : "2px"}}>
            <div style={{borderRadius: "50%", width: index === 0 ? "24px" : "24px", height: index === 0 ? "24px" : "24px", backgroundColor: props.variantsSettings.selectors.colors[index]}}></div>
          </div>)}
        </div>
        }
        </div>}
    </div>
  </div>
}

export const SnippetHtmlVariantsViewer = (props) => {
  const [tagJson, setTagJson] = useState({})
  useEffect(() => {
    if (props.htmlJson) {
      setTagJson(props.htmlJson)
    }
  }, [props.htmlJson])

  return <div className='grid grid-cols-2 gap-x-6'>
      <div className='h-[600px] overflow-auto'>
        <div className='flex flex-row items-center gap-x-1'>
          <div className='text-ccColorDarkTeal font-poppins font-semibold text-lg'>Styles</div>
          <InfoToolTip 
            placement='left'
            headLine='Styles'
            message="Copy these styles and paste them within the <head> section of your email"
          />

        </div>
        <CodeViewer code={tagJson.styles} />
      </div>
      <div>
        {tagJson.tags && tagJson.tags.map((tag, index) =><div className={`${index > 0 ? "mt-2" : ""}`}>
              <div>Element {index +1}</div>
              <div className='h-[360px] overflow-auto'>
                <CodeViewer code={tag} />
              </div>
          </div>
        )}
      </div>

  </div>
}

export default function VariantsViewerWorkFlow(props) {


const initialState = {snippetId: 0, snippetName: '', snippetDesc: '', 
                   labels: [{labelId: 0, labelName: ''}], href: '',
                   snippetTypeId: 21,
                   dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

const routeParams = useParams();
const [workflowDataConnectionId, setWorkflowDataConnectionId] = useState(null);


const [availableFieldsForHref, setAvailableFieldsForHref] = useState([]);



const [activeStep, setActiveStep] = useState(0);
const [snippetInfo, setSnippetInfo] = useState(initialState);
const [submitLoading, setSubmitLoading] = useState(false);
//const [showTemplateInfoForId, setShowTemplateInfoForId] = useState(0);
const [templateDataConnectionMetadata, setTemplateDataConnectionMetadata] = useState({}); // dictionary {templateId: {dataTypeInMetadata: true, filters: filters}}
// templateMetadata: every time user selects a template we need to check for its feed's metadata so that we can populate the filters and order by combos..              
const [templatesMetadata, setTemplatesMetadata] = useState({}); // dictionary {templateId: {metadata: ''}}

const [showSuccessMsg, setShowSuccessMsg] = useState(false);
const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
const [showErrorMsg, setShowErrorMsg] = useState(false);
const [showLoader, setShowLoader] = useState(false);
const [snackBarClipboardOpen, setSnackBarClipboardOpen] = useState(false);

const [templateId, setTemplateId] = useState(undefined); //used to pass to the <VariantsSelector>
const [templateMetadata, setTemplateMetadata] = useState(undefined);
const [workflowNumSnippetsToCreate, setWorkflowNumSnippetsToCreate] = useState(1);

const [activeErrorList, setActiveErrorList] = useState([]);

const navigate = useNavigate();

const [selectedTemplate, setSelectedTemplate] = useState({templateId: undefined});
const [variantsSettings, setVariantsSettings] = useState({})


// load data for edit mode -----
const getSnippetInfo = async (snippetId) => {
   try {
         const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
         const response = await axios.get(url);
       setSnippetInfo(response.data);
       setTemplateId(response.data.templateId)
       const tInfo = await getTemplateMetadata(response.data.templateId)
       tInfo.templateId = response.data.templateId
       setSelectedTemplate(tInfo)
       if (response.data.dataConnectionId !== undefined) {
         const dataTypeInMetadata = response.data.dataConnectionInfo.feedType === 'CATALOG';
         const filters = GetFilterDefFromMetadata(JSON.parse(response.data.dataConnectionInfo.metadata), dataTypeInMetadata);
         setAvailableFieldsForHref(filters.map(f => (f.conditionName)))
         setWorkflowDataConnectionId(response.data.dataConnectionId)
         setVariantsSettings(JSON.parse(response.data.snippetSettings))
       }
       // setCurrentTemplateId(response.data.templateId);
      } catch (error) {
     console.log(error);
   }
 }

const getDataConnectionInfo = async (dataConnectionId) => {
 try {
       const url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
       const response = await axios.get(url);
     
       const dataTypeInMetadata = response.data.feedType === 'CATALOG';
       const filters = GetFilterDefFromMetadata(JSON.parse(response.data.metadata), dataTypeInMetadata);
       setAvailableFieldsForHref(filters.map(f => (f.conditionName)))

       const newTemplateDataConnectionMetadata = {...templateDataConnectionMetadata, [dataConnectionId]:{'dataTypeInMetadata': dataTypeInMetadata, 'filters': filters }}
       setTemplateDataConnectionMetadata(newTemplateDataConnectionMetadata);
       // console.log(newTemplateDataConnectionMetadata)
     
 } catch (error) {
   console.log(error);
 }
}
const getTemplateMetadata = async (templateId) => {
  if (Object.prototype.hasOwnProperty.call(templatesMetadata, templateId)) {
    // console.log('already loaded');
    return;
  }

  try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Templates/info/${templateId}`;
        const response = await axios.get(url);
      
        
 
        const newTemplatesMetadata = {...templatesMetadata, [templateId]:{'metadata': response.data }}
        setTemplatesMetadata(newTemplatesMetadata);
        //console.log(newTemplatesMetadata)

        return response.data
      
  } catch (error) {
    console.log(error);
  }
 }


useEffect(() => {
 if (routeParams.snippetId === undefined) {
           // console.log('New');
        }
       else {
         getSnippetInfo(routeParams.snippetId);
        }
}, []);


useEffect(() => {
  // this is necessary for the edit. 
  // when editing we don't have some objects defined and we need to run "setCurrentTemplateId"
  // in order to have a consistent state
  if (activeStep === 1 && routeParams.id !== undefined) {
    //setCurrentTemplateId(snippetInfo.templateId);
  }

}, [activeStep])

const moveToNextStep = () => {

   const isValidStep = validateStep(activeStep);
   if (isValidStep) {  
     setActiveStep(activeStep + 1);
   }
 }

 const moveToPreviousStep = () => {        
   setActiveStep(activeStep - 1);
 }

 const validateStep = (numStep) => {
   let isValid = true;
   isValid = true;

   switch(numStep) {
        case 0:
            break;
        case 1:
            try {
              snippetDataValidationSchemaVariantViewer_snippetSettings.validateSync({snippetSettings: variantsSettings}, {abortEarly: false});
              setActiveErrorList([])
            }
            catch (e) {
              const errorList = getErrorListFromYupError(e)
              setActiveErrorList(errorList)
              //console.log(errorList)
              return false;
            }

            break;
        case 2:
            break;
        case 3:
            //validation of this steps needs to happen inside the GeneratorElementManager component

            break;
        case 4:
            break;
        default:
           break;
     }
     //console.log(isValid)
     return isValid;
 }


/*
const handleChange = (propName, propValue) => {
  const newSnippetInfo = {...snippetInfo, [propName]: propValue}
  setSnippetInfo(newSnippetInfo);
}
*/


const submitData = async () => {
  try {
    snippetDataValidationSchemaGenerator.validateSync(snippetInfo, {abortEarly: false});
    setActiveErrorList([])
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
    //console.log(errorList)
    return false;
  }

  setShowLoader(true);
  setSubmitLoading(true);
  setSuccessHtmlMsg('');
  const dataToPost = {...snippetInfo, templateId: templateId, snippetSettings: JSON.stringify(variantsSettings)}

  try {
  let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/21`;
  if (routeParams.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/21/${routeParams.snippetId}`;
  // console.log(snippetInfo)
  const response = await axios.post(url, dataToPost);
  setSuccessHtmlMsg(response.data);
  setShowSuccessMsg(true);
  } catch (error) {
  setShowSuccessMsg(false);
  setShowErrorMsg(true);
  console.log(error);
  }
  setShowLoader(false);
  setSubmitLoading(false);
  return true;
}


const copyHtmlCodeToClipboard = (code) => {
setSnackBarClipboardOpen(true);
navigator.clipboard.writeText(code);
}
const handleCloseSnackBarClipboard = () => {
setSnackBarClipboardOpen(false);
}
const SnackBarAction = (
<>
 <IconButton
   size="small"
   aria-label="close"
   color="inherit"
   onClick={handleCloseSnackBarClipboard}
 >
   <Iconify icon={lionIcons.Icon_Actions_Cancel} />
 </IconButton>
</>
);


const handleSnippetChangeNoValidation = (newSnippetInfo) => {
  setSnippetInfo(newSnippetInfo)
  const newNumTags = JSON.parse(newSnippetInfo.snippetSettings).numTags
  setVariantsSettings({...variantsSettings, numTags: newNumTags})
}
const handleSnippetChange = (newSnippetInfo) => {
  setSnippetInfo(newSnippetInfo)
  try {
    snippetDataValidationSchemaGenerator.validateSync(newSnippetInfo, {abortEarly: false});
    setActiveErrorList([])
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
  }

  //console.log(newSnippetInfo)
}
const handleSubmit = async() => {
  const isValid = await submitData()
  if (isValid) setActiveStep(4);
}
  const handleSelectedTemplateChange = async (tInfo) => {
    if (tInfo !== undefined) {
      //setSelectedTemplate(tInfo)
      getDataConnectionInfo(tInfo.dataConnectionId)
      setTemplateId(tInfo.templateId)
    }
    //const newSnippetData = {...snippetInfo, templateId: tInfo.templateId}
    
    //setSnippetInfo(newSnippetData)

    //when we switch template we want to clear all variants settings
    setVariantsSettings({})
    const t = await getTemplateMetadata(tInfo.templateId)
    setSelectedTemplate(t)
  }

  const handleVariantsSettingsChange = (newSettings) => {
    //console.log(newSettings)
    setVariantsSettings(newSettings)
    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaVariantViewer_snippetSettings.validateSync({snippetSettings: newSettings}, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        //console.log(errorList)
      }
    }
  }

 return <>
         <CcStepper2
            steps={[{ name: 'Select a template', href: '#' },
                    { name: 'Configure Variants', href: '#' },
                    { name: 'Element', href: '#' },
                    { name: 'Appearance', href: '#' },
                    { name: 'Confirm', href: '#' },
                ]}
            currentStepIndex={activeStep}
        />


 { activeStep === 0 &&
   <Stack spacing={3}  >
    <CcTitle>Select your template</CcTitle>
<div style={{maxHeight: 'calc(100vh - 300px)'}} className='overflow-auto'>
        <TemplateGalleryViewer productTypeId={1}
        onChange={handleSelectedTemplateChange}
        selectedTemplateId={selectedTemplate.templateId}
        />
      </div>
   </Stack>
  
 }




  {activeStep === 1 && 
    <VariantsSelector
        templateId={templateId}
        variantsSettings={variantsSettings}
        onChange={handleVariantsSettingsChange}
        validationErrorsList={activeErrorList}
    />}



{ activeStep === 2 && <VariantsViewerElementManager
                        templateId={templateId}
                        dataConnectionId={workflowDataConnectionId}
                        snippetInfo={snippetInfo}
                        availableFieldsForHref={availableFieldsForHref}
                        //templateMetadata={templateMetadata}
                        onChange={handleSnippetChange}
                        onNumTagsChange={handleSnippetChangeNoValidation}
                        onNumSnippetsChange={(num) => setWorkflowNumSnippetsToCreate(num)}
                        validationErrorsList={activeErrorList}
                        />

}
{activeStep === 3 && <div className='mb-2'>
  <div className='mb-2'>
    <CcSubSectionTitle>Configure how the variants selectors will look like</CcSubSectionTitle>
  </div>
  <VariantsSelectorManager template={selectedTemplate}
        variantsSettings={variantsSettings}  
        onChange={handleVariantsSettingsChange}
  />
  </div>}

{
       activeStep === 4 &&
         <div>

          {showLoader && <CircularProgress size={64} /> }
           {showSuccessMsg &&<div> <div className='flex justify-center'> 
                                    <div className='w-[440px]'><Alert severity="success" sx={{ml:'15%', mr:'15%'}}>
                                        <AlertTitle>Success</AlertTitle>
                                        <Typography>Element created successfully</Typography>
                                      </Alert>
                                    </div>
                              </div>
                              <div className='mt-4'>
                                  <SnippetHtmlVariantsViewer
                                            htmlJson={successHtmlMsg} />
                              </div>
                         </div>}

           {showErrorMsg && <div className='w-[440px]'><Alert severity="error">
             <AlertTitle>Error</AlertTitle>
             Something went wrong while saving your snippet
           </Alert></div>}
         </div>
   }


{activeStep !== 4 &&
   <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
     {(!showSuccessMsg && !showErrorMsg) && activeStep > 0 && <Button variant="contained" onClick={moveToPreviousStep} sx={{mr:1, backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}}>Previous</Button>} 
     {(!showSuccessMsg && !showErrorMsg) && activeStep < 3 && <Button sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" onClick={moveToNextStep} 
                                                                    >Next</Button>}
     {(!showSuccessMsg && !showErrorMsg) && activeStep === 3 && <LoadingButton sx={{backgroundColor: ccColorTeal, ":hover":{backgroundColor: ccColorDarkTeal}}} variant="contained" 
           onClick={handleSubmit} 
           loading={submitLoading} >Submit</LoadingButton>}
     {(showSuccessMsg || showErrorMsg) && <Button variant="contained" href='/ph/variantsViewer'>Close</Button>}
 </Box>
}

 <Snackbar
   anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
   open={snackBarClipboardOpen}
   autoHideDuration={1500}
   onClose={handleCloseSnackBarClipboard}
   message="Copied to clipboard"
   action={SnackBarAction}
 />



 </>
}
